// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__2RlPc","m-size":"Button_m-size__2eBNi"};